export default "__VITE_ASSET__VIOCA0bN__"